import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_stock_level_monitoring_event_fi_label_hdr_link_RowClass } from '../../../dbschema/bl_inv_stock_level_monitoring_event_fi_label_hdr_link.model';

export class StockLevelMonitoringEventFiLabelHdrLinkModel extends BaseContainerModel {
  bl_inv_stock_level_monitoring_event_fi_label_hdr_link: bl_inv_stock_level_monitoring_event_fi_label_hdr_link_RowClass = new bl_inv_stock_level_monitoring_event_fi_label_hdr_link_RowClass();
}
